// extracted by mini-css-extract-plugin
module.exports = {"terms":"a10a3f92e9--terms--758Uk","term-item":"a10a3f92e9--term-item--zQeuz","term-item__done":"a10a3f92e9--term-item__done--AgXhq"};